import React from 'react';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';

const opciones = [
  { codigo: '', descripcion: '' },
  { codigo: 'L', descripcion: 'Local' },
  { codigo: 'V', descripcion: 'Visitante' },
];

const SelectEquipoAfectado = (props) => {
  const codigoActual = props.codigoActual;
  const estilo = props.estilo;
  const dropUp = props.dropUp;

  const valorActual =
    opciones.find((opcion) => opcion.codigo === (codigoActual || ''))?.descripcion || '';

  const onItemElegido = (opcion) => {
    props.onEquipoAfectadoElegido(opcion.codigo || null);
  };

  return (
    <ComboSelector
      estilo={estilo}
      lista={opciones}
      valorActual={valorActual}
      campoClave={TipoClave.CODIGO}
      campoDescripcion="descripcion"
      dropUp={dropUp}
      onItemElegido={onItemElegido}
    />
  );
};

export default SelectEquipoAfectado;
